import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import updateWorkoutAction from '../update'
import WORKOUTS_ACTION from '../../constants/action'
import { createISOStrDateUtil } from 'packages/src'

function updateStartedAtWorkoutAction () {
  return updateWorkoutAction({
    type: WORKOUTS_ACTION.UPDATE_STARTED_AT,
    payload: {
      key: WORKOUT_KEY.STARTED_AT,
      value: createISOStrDateUtil()
    }
  })
}

export default updateStartedAtWorkoutAction
